import { html } from 'lit';
import { Printer } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-printer')
export class PdsIconPrinter extends PdsIcon {
  @state()
  icon = Printer;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
